var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEvidenceOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_out_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_out_group2",
    transform: "translate(-1139.000000, -292.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_out_group3",
    transform: "translate(1139.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_out_polygon1",
    points: "4.32 7.776 4.32 9.504 12.96 9.504 12.96 7.776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_out_polygon2",
    points: "12.96 0 12.96 1.68 16.32 1.68 16.32 5.04 18 5.04 18 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_out_polygon3",
    points: "0 5.04 1.764 5.04 1.764 1.68 5.04 1.68 5.04 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_out_polygon4",
    points: "16.32 16.32 12.96 16.32 12.96 18 18 18 18 12.96 16.32 12.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_out_polygon5",
    points: "1.764 12.96 0 12.96 0 18 5.04 18 5.04 16.32 1.764 16.32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvidenceOut);
export default __webpack_public_path__ + "static/media/icon_evidence_out.afebc22c.svg";
export { ForwardRef as ReactComponent };